import React from 'react'

const UserInfo = ({ profile_picture_display, name, email }) => {
  return (
    <>
      <div className='flex flex-row items-center gap-3'>
        <div>
          <img
            src={profile_picture_display ?? ''}
            height={40}
            width={40}
            alt='pro'
            className={`aspect-square rounded-full object-cover`}
          />
        </div>
        <div className='flex flex-col items-start'>
          <h2 className='font-bold'>{name}</h2>
          <h2 className='text-sm font-light'>{email}</h2>
        </div>
      </div>
    </>
  )
}

export default UserInfo
